import React from 'react';
import { getPluralSuffix } from '../../../../../utils/plurals';

/**
 * @typedef {object} TimelineUnitGroupUnits
 * @property {string} name
 * @property {number} fei
 */

/**
 * @typedef {object} TimelineUnitGroupProps
 * @property {number} [years]
 * @property {TimelineUnitGroupUnits[]} units
 */

/**
 * @param {TimelineUnitGroupProps} props
 */
const TimelineUnitGroup = props => {
  const { years, units } = props;

  return (
    <div className='timeline-participation-group'>
      {units.map((unit, i) => (
        <div key={i} data-testid={`timeline-unit-${i}`}>
          <p>
            <strong>{unit.name}</strong> - {unit.fei}
          </p>
        </div>
      ))}
      {years !== null && (
        <p>
          <strong>
            Participation: {years} year{getPluralSuffix(years)}
          </strong>
        </p>
      )}
    </div>
  );
};

export default TimelineUnitGroup;
